/* @jsx h */
import { defineComponent, h } from "vue";
import { Order } from "@lemmonhq/types";
import { truncateStaffName } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

interface OrderCardHeaderProps {
  order: Order;
  onCancelOrder: () => void;
}

export const OrderCardHeader = defineComponent<OrderCardHeaderProps>({
  name: "OrderCardHeader",
  props: ["order", "onCancelOrder"],
  setup(props) {
    const { t } = useLocalization();

    return () => {
      const { order } = props;

      return (
        <div
          style={`background: var(--order-card-${
            order.service_method === "takeaway" ? "takeaway" : "dine-in"
          }-background); color: var(--order-card-${
            order.service_method === "takeaway" ? "takeaway" : "dine-in"
          }-content)`}
          class="pl-2 pr-0.5 py-1 flex items-center justify-between"
        >
          <div class="flex flex-1 items-center gap-1">
            <span class="text-1xl">
              {order.service_method === "takeaway" ? (
                <span class="material-symbols-outlined text-sm">moped</span>
              ) : (
                <span class="material-symbols-outlined text-sm ml-0.5">
                  fork_spoon
                </span>
              )}
            </span>
            <span class="uppercase font-semibold">{order.service_method}</span>
          </div>

          {order.user?.name ? (
            <span
              style={"border-color: currentcolor;"}
              class="border p-0.5 uppercase rounded"
            >
              {truncateStaffName(order.user.name)}
            </span>
          ) : null}

          <div class="dropdown dropdown-bottom dropdown-end">
            <div tabindex="0" role="button" class="flex">
              <span class="material-symbols-outlined">more_vert</span>
            </div>
            <ul
              tabindex="0"
              class="dropdown-content text-accent menu bg-base-300 z-[1] w-52 p-0 shadow"
            >
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.onCancelOrder();
                  }}
                >
                  {t("kds.ticket.cancel_order")}
                </a>
              </li>
            </ul>
          </div>
        </div>
      );
    };
  },
});
